/**
 * @fileoverview POST handler for the "/engagement/email_templates/update_archived_state" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementEmailTemplatesUpdateArchivedStateCacheKeys } from "./constants";
import type {
  PostEngagementEmailTemplatesUpdateArchivedStateProps,
  EngagementEmailTemplatesUpdateArchivedStateResult,
} from "./types";

export const postEngagementEmailTemplatesUpdateArchivedState = reactQueryMutationAdapter(
  engagementEmailTemplatesUpdateArchivedStateCacheKeys,
  (
    props: PostEngagementEmailTemplatesUpdateArchivedStateProps
  ): Promise<EngagementEmailTemplatesUpdateArchivedStateResult> => {
    return fetch("/engagement/email_templates/update_archived_state", "POST", props);
  }
);
